import React from 'react';
import PropTypes from 'prop-types';

import { buildClassNames, buildClassNameModifiers } from '../util/utils';
import './divider.scss';

const dividerClassName = 'divider';

export const Divider = ({
                   className,
                   isDivider,
                   inset,
                   ...other
                 }) => (
  <hr
    className={buildClassNames(
      className,
      buildClassNameModifiers(dividerClassName, inset && `inset-${inset}`),
      dividerClassName,
    )}
    {...other}
  />
);

Divider.propTypes = {
  /** @ignore */
  className: PropTypes.string,
  /** @ignore */
  isDivider: PropTypes.bool,
  /** Determines whether the divider will be inset from the edge */
  inset: PropTypes.oneOf(['left', 'right']),
};

Divider.defaultProps = { isDivider: true };
